import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';


const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

export default function CustomToggle({ id, value, onChange, canShowNa }) {

  const handleOnChange = (event, newValue) => {
    if (newValue === null)
      onChange(id, value);
    else
      onChange(id, newValue);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'inline-block',
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <StyledToggleButtonGroup
        size="small"
        color="primary"
        value={value}
        exclusive
        onChange={handleOnChange}
        aria-label="value"
      >
        <ToggleButton value={"Yes"} aria-label="Yes" color="primary">
          {"Yes"}
        </ToggleButton>
        <ToggleButton value={"No"} aria-label="No" color="error">
          {"No"}
        </ToggleButton>
        {
          canShowNa &&
          <ToggleButton value={"N/A"} aria-label="N/A" color="secondary">
            {"N/A"}
          </ToggleButton>
        }
      </StyledToggleButtonGroup>
    </Paper>
  );
}
